import React, { useEffect, useState } from "react";
import MyAccount from "./MyAccount";
import OrderList from "./OrderComp";
import OrderDetails from "./OrderComp/OrderDetails";
import AddressList from "./AdreessComp";
import MyDetails from "./MydetailsComp";
import styles from "./AccountDashboard.module.scss";
import { customerOrderList } from "@/helpers/orderHelper";
import { getCookie, setCookie } from "cookies-next";
import Impact from "./ImpactComp";
import { useSelector } from "react-redux";
import Wishlist from "@/components/Wishlist";
import { useRouter } from "next/compat/router";
import { bodyOverflow } from "@/helpers/userHelpers";
import { formatDate } from "@/helpers/pdpHelpers/dateHelpers";
import { getCauseDetailsByName } from "@/helpers/charityHelper";
import Srcset from "@/components/common/Srcset";
import Help from "@/components/Help";

const MyAccountDashboard = (props) => {
  const router = useRouter();
  const { userName, DashboardCloseRef, userDetails, yotpoDetails } = props;
  const [activeTag, setActiveTab] = useState("");
  const [orderId, setActiveOrder] = useState("");
  const [editPageState, setEditPageState] = useState("");
  const activeTab = (tab) => setActiveTab(tab);
  const [noOrder, setNoOrder] = useState(false);
  const [ordersList, setOrderList] = useState([]);
  const [impactMessage, setImpactMessage] = useState(false);
  const [charityLogo, setCharityLogo] = useState(false);
  const [noOfOrders,setNoOfOrders] = useState(0)
  const setGloballyActiveTab = useSelector((state) => state.general.global_active_tab);
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  useEffect(() => {
    if (props.drawer_tab === "orders" && props.drawer_order_id) {
      //setActiveTab('orderDetailsTab')
    } else if (props.drawer_tab === "orders" || setGloballyActiveTab === "orders") {
      setActiveTab("ordersTab");
    } else if (props.drawer_tab === "address" || setGloballyActiveTab === "address") {
      setActiveTab("addressListTab");
    } else if (props.drawer_tab === "my-impact" || setGloballyActiveTab === "my-impact") {
      setActiveTab("impactTab");
    } else if (props.drawer_tab === "wishlist" || setGloballyActiveTab === "wishlist") {
      setActiveTab("myWishlistTab");
    } else if (props.drawer_tab === "my-details" || setGloballyActiveTab === "my-details") {
      setActiveTab("myDetailsTab");
    } else if (props.drawer_tab === "help" || setGloballyActiveTab === "help") {
      setActiveTab("helpTab");
    } else {
      setActiveTab("");
    }
  }, [props.drawer_tab, setGloballyActiveTab]);
  useEffect(() => {
    if(props.myAccount == 'account')
      setActiveTab("");
  }, [props.myAccount]);

  const getCustomerOrders = async (token) => {
    const {orders,totalCount} = await customerOrderList({
      token: token,
    });
    if (!orders?.length) {
      setNoOrder(true);
    } else {
      setNoOfOrders(totalCount)
      let totalCauseAmount = 0;
      let firstOrderDate = "";
      let impactMessage = "";
      let benefitLogo = "images/Logo/Charity-Oli.png";
      let isDefaultLogo = true;
      if (orders && orders?.length) {
        orders.forEach((order) => {
          if (order?.causeAmount?.value && order?.causeAmount?.value > 0) {
            totalCauseAmount += parseFloat(order.causeAmount.value);
            firstOrderDate = order.processedAt ? order.processedAt : "";
          }
        });
      }
      if (totalCauseAmount > 0 && firstOrderDate) {
        const cause = getCauseDetailsByName("care");
        if (
          cause?.length > 0 &&
          typeof cause[0] != "undefined" &&
          typeof cause[0].benefit_logo != "undefined" &&
          typeof cause[0].share_percentage != "undefined" &&
          typeof cause[0].benefit_unit != "undefined" &&
          typeof cause[0].benefit_text != "undefined"
        ) {
          benefitLogo = cause[0].benefit_logo;
          isDefaultLogo = false;
          let benefitUnit = (totalCauseAmount) / 3; //consolidated benefit value is always divided by 3
          if (benefitUnit < 1) {
            benefitUnit = 1;
          }
          let benifitSubtext = Math.floor(benefitUnit) > 1 ? cause[0].benefit_text.replace("#", ""):cause[0].benefit_text.replace("#s", "");

          impactMessage +=
            Math.floor(benefitUnit) +
            " " +
            benifitSubtext +
            " since " +
            formatDate(firstOrderDate);
        }
        setImpactMessage(impactMessage);
        setCharityLogo(
          <Srcset
            height="18"
            width="18"
            alt="Charity icon"
            requirePath={isDefaultLogo}
            svgFile={true}
            src={benefitLogo}
            className={`${styles.charity_brand}`}
          />
        );
      }
    }
    let flag = false;
    if (router?.asPath.includes("account/orders")) {
      if (orders && orders?.length && props.drawer_order_id) {
        orders.forEach((order) => {
          const orderName = order.name.replace('#', '')
          if (orderName == props.drawer_order_id) {
            setActiveOrder(order.id);
            setActiveTab("orderDetailsTab");
            flag = true;
            return;
          }
        });
      }
      if (props.drawer_order_id && !flag) {
        setActiveTab("ordersTab");
        setActiveOrder("");
      }
    }
    setOrderList(orders);
  };
  useEffect(() => {
    document.body.classList.add("overflow");

    if (getCookie("userdataToken")) {
      let cookie_data = JSON.parse(getCookie("userdataToken"));
      getCustomerOrders(cookie_data.accessToken);
    }
    return () => {
      document.body.classList.remove("overflow");
    };
  }, []);

  useEffect(() => {
    if(noOrder){
      setCookie("is_new_customer",true, { maxAge: 6 * 30 * 24 * 3600 });
    }
    else{
      setCookie("is_new_customer",false, { maxAge: 6 * 30 * 24 * 3600 });
    }
  }, [noOrder]);

  useEffect(() => {
    if(typeof document !== undefined && isPWA){
      let ele = document.querySelectorAll(".back_icon")
      console.log(ele)
      ele.forEach((item)=>{
        console.log(item)
        item.style.top = "65px"
      })
    }
  },[activeTab])

  return (
    <>
      {(!activeTag || activeTag== '' || activeTag == null)  && (
        <MyAccount
          DashboardCloseRef={DashboardCloseRef}
          styles={styles}
          activeTab={activeTab}
          userName={userName}
          impactMessage={impactMessage}
          charityLogo={charityLogo}
          yotpoDetails={yotpoDetails}
        />
      )}
      {activeTag === "ordersTab" && (
        <OrderList
          styles={styles}
          activeTab={activeTab}
          setActiveOrder={setActiveOrder}
          setAccountSidebarOpen={props.setAccountSidebarOpen}
          noOrder={noOrder}
          noOfOrders={noOfOrders}
          ordersList={ordersList}
        />
      )}
      {activeTag === "orderDetailsTab" && (
        <OrderDetails
          styles={styles}
          activeTab={activeTab}
          setAccountSidebarOpen={props.setAccountSidebarOpen}
          orderId={orderId}
        />
      )}
      {activeTag === "addressListTab" && (
        <AddressList styles={styles} activeTab={activeTab} />
      )}
      {activeTag === "impactTab" && (
        <Impact
          styles={styles}
          activeTab={activeTab}
          setAccountSidebarOpen={props.setAccountSidebarOpen}
          impactMessage={impactMessage}
          charityLogo={charityLogo}
        />
      )}
      {(activeTag === "myDetailsTab") && (
        <MyDetails
          styles={styles}
          activeTab={activeTab}
          userDetails={userDetails}
          setAccountSidebarOpen={props.setAccountSidebarOpen}
          setEditPageState={setEditPageState}
          //editPageState={props.editPageState}
          //setEditPageState={props.setEditPageState}
          root="my-details"
        />
      )}
      {(activeTag === "myDetailsTabEdit") && (
        <MyDetails
          styles={styles}
          activeTab={activeTab}
          userDetails={userDetails}
          setAccountSidebarOpen={props.setAccountSidebarOpen}
          //editPageState={props.editPageState}
          //setEditPageState={props.setEditPageState}
          root="my-details-edit"
          editPageState={editPageState}
          setEditPageState={setEditPageState}
        />
      )}
      {activeTag === "myWishlistTab" && (
        <Wishlist
          styles={styles}
          activeTab={activeTab}
          setAccountSidebarOpen={props.setAccountSidebarOpen}
          parentClass={"account-tab-open"}
        />
      )}
      {activeTag === "helpTab" && (
        <Help
          styles={styles}
          activeTab={activeTab}
          setAccountSidebarOpen={props.setAccountSidebarOpen}
          //parentClass={"account-tab-open"}
        />
      )}
    </>
  );
};

export default MyAccountDashboard;
